import { P2GText } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import AlertWithIcon from '../../../AlertWithIcon';
import { SvgConfirmCircle, SvgEnquiryExclamation } from '@parcel2go/core-ui';

export type confirmType = 'LABELS' | 'EXTERNAL';

export interface confirmItem {
  type: confirmType;
  confirmed: boolean;
  count: number;
}

interface props {
  confirmed: confirmItem[];
  onClick: (type: confirmType, done: boolean) => void;
  labelSummary?: ReactNode;
}

const Confirm: React.FC<props> = (props) => {
  if (!props.confirmed || props.confirmed.length === 0) {
    return null;
  }

  const allDone = props.confirmed.filter((x) => x.confirmed).length === props.confirmed.length;

  return (
    <AlertWithIcon
      color={allDone ? 'success' : undefined}
      icon={allDone ? <SvgConfirmCircle /> : <SvgEnquiryExclamation />}
      iconSrc={allDone ? '/theme/icons/ConfirmCircle.svg' : '/theme/icons/EnquiryExclamation.svg'}
    >
      {props.confirmed.map((c) => {
        switch (c.type) {
          case 'LABELS':
            return (
              <P2GCheckBoxLegacy
                key={c.type}
                id="Downloaded"
                labelPlacement="end"
                checked={c.confirmed}
                label={
                  <>
                    <P2GText variant="body2">I have downloaded my labels.</P2GText>
                    {props.labelSummary}
                  </>
                }
                onChange={(s) => props.onClick(c.type, s)}
                variant="primary"
                error={false}
              />
            );
          case 'EXTERNAL':
            return (
              <P2GCheckBoxLegacy
                key={c.type}
                id="Downloaded"
                labelPlacement="end"
                checked={c.confirmed}
                label={
                  <P2GText variant="body2">I have downloaded my labels, following payment via the link below.</P2GText>
                }
                onChange={(s) => props.onClick(c.type, s)}
                variant="primary"
                error={false}
              />
            );
        }
      })}
    </AlertWithIcon>
  );
};
export default Confirm;
